
  var _styles = {
  "winner-list-modal__wrapper": {
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "winner-list-modal__content-wrapper": {
    "width": "8rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.42667rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "overflow": "hidden",
    "position": "relative"
  },
  "winner-list-modal__header-gradient": {
    "width": "8rem",
    "height": "2.13333rem",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "winner-list-modal__header-title": {
    "fontSize": "0.45333rem",
    "lineHeight": "0.82667rem",
    "fontWeight": "600",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "textAlign": "center"
  },
  "winner-list-modal__header-image": {
    "width": "7.52rem",
    "height": "1.28rem"
  },
  "winner-list-modal__sub-title": {
    "marginBottom": "0.10667rem",
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)",
    "fontFamily": "PingFang SC",
    "textAlign": "center"
  },
  "winner-list-modal__list-wrapper": {
    "width": "8rem",
    "height": "9.2rem",
    "position": "relative"
  },
  "winner-list-modal__scroll-content": {
    "width": "8rem",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "flex-start"
  },
  "winner-list-modal__item": {
    "width": "8rem",
    "flexDirection": "column",
    "alignItems": "center"
  },
  "winner-list-modal__item-divider": {
    "width": "7.14667rem",
    "height": "0.02667rem",
    "backgroundColor": "rgb(245,245,245)"
  },
  "winner-list-modal__item-row": {
    "width": "7.14667rem",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingTop": "0.32rem",
    "paddingBottom": "0.32rem"
  },
  "winner-list-modal__item-index": {
    "width": "0.53333rem",
    "fontSize": "0.37333rem",
    "lineHeight": "0.66667rem",
    "color": "rgb(153,153,153)",
    "fontFamily": "PingFang SC",
    "textAlign": "center",
    "marginRight": "0.21333rem"
  },
  "winner-list-modal__item-name": {
    "flex": 1,
    "fontSize": "0.4rem",
    "lineHeight": "0.72rem",
    "fontWeight": "600",
    "color": "rgb(26,26,26)",
    "fontFamily": "PingFang SC"
  },
  "winner-list-modal__item-tag": {
    "fontSize": "0.34667rem",
    "lineHeight": "0.61333rem",
    "color": "rgb(153,153,153)",
    "fontFamily": "PingFang SC"
  },
  "winner-list-modal__scroll-footer": {
    "width": "8rem",
    "height": "1.33333rem"
  },
  "winner-list-modal__bottom-gradient": {
    "position": "absolute",
    "bottom": 0,
    "width": "8rem",
    "height": "1.6rem"
  },
  "winner-list-modal__confirm-btn": {
    "width": "7.14667rem",
    "height": "1.17333rem",
    "backgroundColor": "rgb(255,237,75)",
    "borderRadius": "0.58667rem",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "marginTop": "0.32rem",
    "marginBottom": "0.42667rem"
  },
  "winner-list-modal__confirm-btn-text": {
    "fontSize": "0.42667rem",
    "lineHeight": "0.77333rem",
    "fontWeight": "600",
    "color": "rgb(26,26,26)",
    "fontFamily": "PingFang SC"
  },
  "cfe-five-city-close-button": {
    "marginTop": "0.70667rem"
  },
  "cfe-five-city-close-button-img": {
    "width": "0.64rem",
    "height": "0.64rem"
  }
};



  module.exports = _styles;
  